// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__oNewC","content":"RecentSearches_content__kJ0TG"};